/* eslint-disable no-duplicate-imports */

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig from '@/../themeConfig.js'
import colors from '@/../themeConfig.js'

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  name: '', // From Auth
  about: 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
  avatar: require('@/assets/images/portrait/small/avatar-default.jpg'), // From Auth
  status: 'online',
  userRole: 'admin'
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser           : userDefaults,
  bodyOverlay             : false,
  isVerticalNavMenuActive : true,
  is_touch_device         : is_touch_device(),
  mainLayoutType          : themeConfig.mainLayoutType || 'vertical',
  navbarSearchAndPinList,
  reduceButton            : themeConfig.sidebarCollapsed,
  verticalNavMenuWidth    : 'default',
  verticalNavMenuItemsMin : false,
  scrollY                 : 0,
  starredPages            : navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
  theme                   : themeConfig.theme || 'light',
  themePrimaryColor       : colors.primary,
  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
  ///////////////////
  user: null,
  userRoles: null,
  userAvatar: null,
  usersPDN: [],
  employees: [],
  employee: [],
  roles: [],
  departments: [],
  headquarters: [],
  businessTypes: [],
  businessSectors: [],
  clientsPDN: [],
  clientsAddedServices: [],
  clientsInmigration: [],
  countries: [],
  clientInfo: [],
  clientTimeline: [],
  payments: [],
  paymentsClient: [],
  paymentsClientNoneService: [],
  employeeInfo: [],
  cities: [],
  provinces: [],
  municipalities: [],
  districts: [],
  neighborhoods: [],
  district: [],
  neighborhood: [],
  businesses: [],
  businessTimeline: [],
  businessInfo: [],
  contacts: [],
  documents: [],
  clientRequests: [],
  clientRequestsForAClient: [],
  notifications: [],
  assignedAdvisors: [],
  assignedAdvisor: [],
  assignedClients: [],
  myRequests: [],
  videoCallTypesAdmin: [],
  videoCalls: [],
  videoCallsPerAdvisor: [],
  videoCallsPerClient: [],
  services: [],
  financialAnalysesForAClient: [],
  addedServicesForAClient: [],
  myFinancialAnalysis: [],
  userCommentTypes: [],
  UserCommentsForAClient: [],
  userComments: [],
  visaTypes: [],
  clientFamily: [],
  visaDocumentTypes: [],
  familyTypes: [],
  addedServicesForAClientInmigration: [],
  addedServicesForAClientInmigrationActive: [],
  visaRequirements: [],
  arrivalDate: null,
  visaStepsForAClient: [],
  visaStepTypes: [],
  totalClientsByPlan: [],
  inmigrationClients: [],
  mondayLinks: [],
  // Calendar Labels
  eventLabels: [
    {
      text: 'Verde',
      value : 'verde',
      color: 'success'
    },
    {
      text: 'Naranja',
      value: 'naranja',
      color: 'warning'
    },
    {
      text: 'Rojo',
      value: 'rojo',
      color: 'danger'
    },
    {
      text: 'Negro',
      value: 'negro',
      color: 'dark'
    },
    {
      text: 'Gris Claro',
      value: 'gris-claro',
      color: 'grey-light'
    },
    {
      text: 'Azul',
      value: 'azul',
      color: 'primary'
    }
    
  ],
  // Simple Calendar State
  events: [],
  pasos: [
    {
      id: 1,
      name: 'Presentación Cliente',
      created_at: '2021-05-24',
      completed: true,
      error: false
    },
    {
      id: 2,
      name: 'Solicitud de Información',
      created_at: '2021-05-26',
      completed: false,
      error: false
    },
    {
      id: 3,
      name: 'Entrega de documentos',
      created_at: '2021-05-26',
      completed: false,
      error: false
    },
    {
      id: 4,
      name: 'Revisión de documentos',
      created_at: '2021-05-26',
      completed: false,
      error: false
    },
    {
      id: 5,
      name: 'Introducción de Expediente',
      created_at: '2021-05-26',
      completed: false,
      error: false
    },
    {
      id: 6,
      name: 'Resolución',
      created_at: '2021-05-26',
      completed: false,
      error: false
    },
    {
      id: 7,
      name: 'Tarjeta de Expedición',
      created_at: '2021-05-26',
      completed: false,
      error: false
    }
  ],
  documentos_extranjeria: [
    {
      id: 1,
      name: 'Formulario Solicitud Visado Nacional',
      created_at: '2021-05-26',
      flag_active: 1,
      aplica: 'Arraigo Social, Asilo, Razones Humanitarias, Reagrupación Familiar - Comunitario, Reagrupación Familiar - Residente, Visado de Estudiantes, Visado Golden, Visado Intrempresarial, Visado No Lucrativo, Visado Profesional Altamente Cualificado'
    },
    {
      id: 2,
      name: 'Fotografía',
      created_at: '2021-05-26',
      flag_active: 1,
      aplica: 'Arraigo Social, Asilo, Razones Humanitarias, Reagrupación Familiar - Comunitario, Reagrupación Familiar - Residente, Visado de Estudiantes, Visado Golden, Visado Intrempresarial, Visado No Lucrativo, Visado Profesional Altamente Cualificado'
    },
    {
      id: 3,
      name: 'Pasaporte',
      created_at: '2021-05-26',
      flag_active: 1,
      aplica: 'Arraigo Social, Asilo, Razones Humanitarias, Reagrupación Familiar - Comunitario, Reagrupación Familiar - Residente, Visado de Estudiantes, Visado Golden, Visado Intrempresarial, Visado No Lucrativo, Visado Profesional Altamente Cualificado'
    },
    {
      id: 4,
      name: 'Acreditación de Recursos Económicos',
      created_at: '2021-05-26',
      flag_active: 1,
      aplica: 'Arraigo Social, Asilo, Razones Humanitarias, Reagrupación Familiar - Comunitario, Reagrupación Familiar - Residente, Visado de Estudiantes, Visado Golden, Visado Intrempresarial, Visado No Lucrativo, Visado Profesional Altamente Cualificado'
    },
    {
      id: 5,
      name: 'Acta de Matrimonio',
      created_at: '2021-05-26',
      flag_active: 1,
      aplica: 'Arraigo Social, Asilo, Razones Humanitarias, Reagrupación Familiar - Comunitario, Reagrupación Familiar - Residente, Visado de Estudiantes, Visado Golden, Visado Intrempresarial, Visado No Lucrativo, Visado Profesional Altamente Cualificado'
    },
    {
      id: 6,
      name: 'Acta de Nacimiento',
      created_at: '2021-05-26',
      flag_active: 1,
      aplica: 'Arraigo Social, Asilo, Razones Humanitarias, Reagrupación Familiar - Comunitario, Reagrupación Familiar - Residente, Visado de Estudiantes, Visado Golden, Visado Intrempresarial, Visado No Lucrativo, Visado Profesional Altamente Cualificado'
    },
    {
      id: 7,
      name: 'Seguro Médico',
      created_at: '2021-05-26',
      flag_active: 1,
      aplica: 'Arraigo Social, Asilo, Razones Humanitarias, Reagrupación Familiar - Comunitario, Reagrupación Familiar - Residente, Visado de Estudiantes, Visado Golden, Visado Intrempresarial, Visado No Lucrativo, Visado Profesional Altamente Cualificado'
    },
    {
      id: 8,
      name: 'Antecedentes Penales',
      created_at: '2021-05-26',
      flag_active: 1,
      aplica: 'Arraigo Social, Asilo, Razones Humanitarias, Reagrupación Familiar - Comunitario, Reagrupación Familiar - Residente, Visado de Estudiantes, Visado Golden, Visado Intrempresarial, Visado No Lucrativo, Visado Profesional Altamente Cualificado'
    },
    {
      id: 9,
      name: 'Certificado Médico',
      created_at: '2021-05-26',
      flag_active: 1,
      aplica: 'Arraigo Social, Asilo, Razones Humanitarias, Reagrupación Familiar - Comunitario, Reagrupación Familiar - Residente, Visado de Estudiantes, Visado Golden, Visado Intrempresarial, Visado No Lucrativo, Visado Profesional Altamente Cualificado'
    }
  ]
}

export default state
